export enum OnboardingApplicationStatus {
  RESTRICTED_STANDARD = 'RESTRICTED_STANDARD',
  MDT_STANDARD = 'MDT_STANDARD',
  MDT_STANDARD_PENDING = 'MDT_STANDARD_PENDING',
  RESTRICTED_STANDARD_PENDING = 'RESTRICTED_STANDARD_PENDING',
}
